import { useMutation } from "@tanstack/react-query"

import { useSearchParams } from "react-router-dom"
import { API_OTP_AUTH_URL } from "../constants"
import { axios } from "../axios"
import { IRequestOtpResponse } from "../interface"
import { QUERY_PARAMS_EXCHANGE_TOKEN_KEY } from "../../utils/constants"

const resendOtp = async (exchangeToken: string | undefined) => {
  const response = await axios.post(`${API_OTP_AUTH_URL}`, null,{
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${exchangeToken}`,
    },
  })
  return response.data
}

export const useResendOtpAuthRequest = () => {
  const [searchParams] = useSearchParams()
  const exchangeToken = searchParams.get(QUERY_PARAMS_EXCHANGE_TOKEN_KEY)

  return useMutation<IRequestOtpResponse, void>({
    mutationFn: () => resendOtp(exchangeToken!),
    retry: false,
  })
}
